import React from "react";
import { useTranslation } from "react-i18next";

import { LegendGradientItemStyle, legendStyle } from "./style";
import { snowLegendColors } from "../util/colors";

const Snow25CMLegend = () => {
  const { t } = useTranslation();

  const snow25CMLegendLegendLevelsStr = [
    `${t("levels.low")} : (0 ≤ ps(%) < 10)`,
    `${t("levels.moderate")} : (10 ≤ ps(%) < 20)`,
    `${t("levels.significant")} : (20 ≤ ps(%) < 50)`,
    `${t("levels.high")} : (50 ≤ ps(%) < 100)`,
  ];

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.snow")} (ITA) - 25cm</b>
      </div>

      <LegendGradientItemStyle
        colors={snowLegendColors}
        labels={snow25CMLegendLegendLevelsStr}
      ></LegendGradientItemStyle>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          ps (%) = {t("legend.snowAnnualProbability")} &lt; 25cm/{t("day")}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};

export default Snow25CMLegend;
